import { render, staticRenderFns } from "./CaseAddressImportDialog.vue?vue&type=template&id=2ffb7edf&"
import script from "./CaseAddressImportDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaseAddressImportDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports